import {tr} from '../i18n/idioma';
import {numero} from '../utilidades/formato';

type Props = {
  pagina: number;
  totalPaginas: number;
  porPagina: number;
  total: number;
  onPagina: (pagina: number) => void;
  onPorPagina: (porPagina: number) => void;
  // Que se cuenta (por defecto Big Bags); en el seguimiento, exportaciones.
  unidad?: {es: string; en: string};
};

const TAMANOS = [50, 100, 200, 500];

export function Paginacion({
  pagina,
  totalPaginas,
  porPagina,
  total,
  onPagina,
  onPorPagina,
  unidad = {es: 'Big Bags', en: 'Big Bags'},
}: Props) {
  const desde = total === 0 ? 0 : (pagina - 1) * porPagina + 1;
  const hasta = Math.min(pagina * porPagina, total);
  const boton =
    'rounded-md border border-linea bg-white px-2.5 py-1 text-sm hover:bg-papel disabled:cursor-not-allowed disabled:opacity-40';
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 text-sm">
      <div className="text-apagado">
        {total === 0
          ? tr('Sin resultados', 'No results')
          : tr(
              `${numero(desde)} a ${numero(hasta)} de ${numero(total)} ${unidad.es}`,
              `${numero(desde)} to ${numero(hasta)} of ${numero(total)} ${unidad.en}`,
            )}
      </div>
      <div className="flex items-center gap-2">
        <label className="text-xs text-apagado">
          {tr('Por página', 'Per page')}
          <select
            value={porPagina}
            onChange={e => onPorPagina(Number(e.target.value))}
            className="ml-1 rounded-md border border-linea bg-white px-2 py-1 text-sm text-tinta"
          >
            {TAMANOS.map(t => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </label>
        <button
          type="button"
          className={boton}
          onClick={() => onPagina(1)}
          disabled={pagina <= 1}
          aria-label={tr('Primera página', 'First page')}
        >
          «
        </button>
        <button
          type="button"
          className={boton}
          onClick={() => onPagina(pagina - 1)}
          disabled={pagina <= 1}
          aria-label={tr('Página anterior', 'Previous page')}
        >
          ‹
        </button>
        <span className="px-1 tabular-nums">
          {numero(pagina)} / {numero(Math.max(totalPaginas, 1))}
        </span>
        <button
          type="button"
          className={boton}
          onClick={() => onPagina(pagina + 1)}
          disabled={pagina >= totalPaginas}
          aria-label={tr('Página siguiente', 'Next page')}
        >
          ›
        </button>
        <button
          type="button"
          className={boton}
          onClick={() => onPagina(totalPaginas)}
          disabled={pagina >= totalPaginas}
          aria-label={tr('Última página', 'Last page')}
        >
          »
        </button>
      </div>
    </div>
  );
}
